import React from 'react';
import AppImage from './AppImage';

export default class AppAvatar extends React.Component {

  render() {
    let { profile } = this.props;
    let fullname = profile.fullName;
    let matches = fullname.split(" ").map((n)=>n[0]);
    let initials = matches.join('');
    let profileImg = null;

    let styles = {};

    // if(this.props.size) {
    //   styles.width = this.props.size;
    //   styles.height = this.props.size;
    // }

    let classNames = [
      'homeProfilePicture'
    ];

    if(!this.props.shadow) {
      classNames.push('no-shadow');
    }

    if (profile.image) {
      profileImg = (<AppImage src={profile.imagePath} alt="profile image" className={'profile-image'} />);
    } else {
      profileImg = <div className={classNames.join(' ')} {...this.props} style={{...this.props.style, ...styles}}><h2 style={{ fontSize: this.props.size ? this.props.size / 2.5 : 72, color: 'white' }}>{initials}</h2></div>
    }

    return profileImg;
  }
}

AppAvatar.defaultProps = {
  style: {},
  size: 150,
  shadow: true
}



// WEBPACK FOOTER //
// ./src/components/images/AppAvatar.js